import React, { useCallback, useMemo } from 'react'
import PropTypes from 'prop-types'
import { isEmpty } from 'ramda'
import { Row, Col } from 'components/patterns'
import SwitchDetailCard from '../SwitchDetailCard'
import { SwitchListContainer } from './InputSwitchList.style'

const InputSwitchList = ({
  handleSwitchSelection,
  className,
  selectedInputDetails,
  selectedSwitches,
}) => {
  const { switches, id } = selectedInputDetails

  const onSwitchSelect = useCallback(
    (switchNumber) => {
      handleSwitchSelection(switchNumber)
    },
    [handleSwitchSelection]
  )

  const renderSwitchDetailsCard = useMemo(() => {
    if (isEmpty(switches)) return false
    const sortedSwitches = [...switches].sort((a, b) =>
      (a.panelNumber || '').localeCompare(b.panelNumber || '')
    )
    // Only disable on-vehicle switches when there's exactly one match.
    // Multiple on-vehicle matches require explicit user choice.
    const onVehicleCount = switches.filter((s) => s.isSwitchOnVehicle).length
    return sortedSwitches.map((inputSwitch) => {
      const { panelNumber, panelDescription, type, isSwitchOnVehicle } =
        inputSwitch
      return (
        <Col span={12} key={panelNumber}>
          <SwitchDetailCard
            className={`switch-${panelNumber}`}
            key={panelNumber}
            panelNumber={panelNumber}
            handleSwitchSelection={onSwitchSelect}
            selectedPanelNumber={selectedSwitches[id]}
            panelDescription={panelDescription}
            type={type}
            disabled={isSwitchOnVehicle && onVehicleCount === 1}
          />
        </Col>
      )
    })
  }, [onSwitchSelect, id, switches, selectedSwitches])

  return (
    <SwitchListContainer className={className}>
      <Row gutter={[16, 16]} style={{ rowGap: 16 }}>
        {renderSwitchDetailsCard}
      </Row>
    </SwitchListContainer>
  )
}

InputSwitchList.propTypes = {
  handleSwitchSelection: PropTypes.func,
  className: PropTypes.string,
  selectedSwitches: PropTypes.object,
  selectedInputDetails: PropTypes.object,
}

export default InputSwitchList
